export const LOW_RISK = 'LOW_RISK';
export const MEDIUM_RISK = 'MEDIUM_RISK';
export const HIGH_RISK = 'HIGH_RISK';
